import {keepPreviousData, useQuery} from '@tanstack/react-query'
import {useShowError} from '@hooks/useShowError/useShowError'
import {QUERY_KEY_RECORDINGS_UPLOADED} from '@containers/monitoringPlatform/geoZones/queryHooks/constants/queryKey'
import {getRecordingsUploadedListApi} from '@containers/monitoringPlatform/geoZones/api/api'


export const useGetRecordingsUploadedListQuery = (
	accountId: number,
	inGeozoneOnly: boolean,
	singleVoyage: boolean = false
) => {

	const {onShowError} = useShowError()

	return useQuery({
		queryFn: () => getRecordingsUploadedListApi(accountId, inGeozoneOnly, singleVoyage, onShowError),
		queryKey: [QUERY_KEY_RECORDINGS_UPLOADED, accountId?.toString(), inGeozoneOnly, singleVoyage],
		staleTime: 1000 * 60 * 5,
		enabled: !!accountId,
		placeholderData: keepPreviousData,
	})
}
